var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83415 12.8333L13.7091 6.95829L12.5425 5.79163L7.83415 10.5L5.45915 8.12496L4.29248 9.29163L7.83415 12.8333ZM9.00081 17.3333C7.84804 17.3333 6.7647 17.1145 5.75081 16.677C4.73693 16.2395 3.85498 15.6458 3.10498 14.8958C2.35498 14.1458 1.76123 13.2638 1.32373 12.25C0.88623 11.2361 0.66748 10.1527 0.66748 8.99996C0.66748 7.84718 0.88623 6.76385 1.32373 5.74996C1.76123 4.73607 2.35498 3.85413 3.10498 3.10413C3.85498 2.35413 4.73693 1.76038 5.75081 1.32288C6.7647 0.885376 7.84804 0.666626 9.00081 0.666626C10.1536 0.666626 11.2369 0.885376 12.2508 1.32288C13.2647 1.76038 14.1466 2.35413 14.8966 3.10413C15.6466 3.85413 16.2404 4.73607 16.6779 5.74996C17.1154 6.76385 17.3341 7.84718 17.3341 8.99996C17.3341 10.1527 17.1154 11.2361 16.6779 12.25C16.2404 13.2638 15.6466 14.1458 14.8966 14.8958C14.1466 15.6458 13.2647 16.2395 12.2508 16.677C11.2369 17.1145 10.1536 17.3333 9.00081 17.3333Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/complete.5fe4a11f30f00220f35672ab2dd2c2b3.svg";
export { ForwardRef as ReactComponent };